module.exports = __webpack_public_path__ + "img/zght_jxk.9207a22a.svg";